/* Elegance Coque — confirmation commune après « Ajouter » :
   « Produit ajouté au panier ✓ » + grand bouton doré « Voir mon panier ».
   Remplace les petits messages des cartes produits, fiches, barre mobile et accessoires. */
(function () {
  if (window.__ecAdded) { return; }
  window.__ecAdded = 1;
  var d = document;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var box, lastFocus, showT = 0;

  function build() {
    box = d.createElement('div');
    box.className = 'ec-add';
    box.hidden = true;
    box.innerHTML =
      '<div class="ec-add__ov" data-ec-add-close></div>' +
      '<div class="ec-add__box" role="dialog" aria-modal="true" aria-labelledby="ec-add-t">' +
        '<button type="button" class="ec-add__x" data-ec-add-close aria-label="Fermer">&times;</button>' +
        '<p class="ec-add__t" id="ec-add-t">Produit ajouté au panier <span aria-hidden="true">✓</span></p>' +
        '<a class="ec-add__cta" href="' + root + 'cart">Voir mon panier</a>' +
        '<button type="button" class="ec-add__cont" data-ec-add-close>Continuer mes achats</button>' +
      '</div>';
    d.body.appendChild(box);
    box.addEventListener('click', function (e) {
      if (e.target.closest('[data-ec-add-close]')) { close(); }
    });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && box && !box.hidden) { close(); }
    });
  }

  function show() {
    var now = Date.now();
    if (now - showT < 300) { return; }
    showT = now;
    if (!box) { build(); }
    if (box.hidden) { lastFocus = d.activeElement; }
    box.hidden = false;
    void box.offsetWidth;
    box.classList.add('is-on');
    var cta = box.querySelector('.ec-add__cta');
    if (cta) { try { cta.focus({ preventScroll: true }); } catch (e) { cta.focus(); } }
  }

  function close() {
    if (!box || box.hidden) { return; }
    box.classList.remove('is-on');
    setTimeout(function () { box.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus && d.contains(lastFocus)) {
      try { lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  window.ecShowAdded = show;

  /* Petits messages existants : on les masque et on affiche la confirmation commune. */
  var SEL = '.ec-toast,.ecca-toast,.ecx-toast,.lsb-toast,[data-lau-toast]';
  var OK = /ajout[ée]e?\s+au\s+panier/i, KO = /n.?a pas abouti|erreur|impossible/i;

  function check(el) {
    var txt = el.textContent || '';
    if (OK.test(txt) && !KO.test(txt)) {
      el.style.setProperty('display', 'none', 'important');
      show();
    } else {
      el.style.removeProperty('display');
    }
  }

  function scan(node) {
    if (!node || node.nodeType !== 1) { node = node && node.parentNode; }
    if (!node || node.nodeType !== 1) { return; }
    var el = node.closest ? node.closest(SEL) : null;
    if (el) { check(el); }
  }

  function start() {
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) {
        var m = ms[i];
        if (m.type === 'childList' && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) { scan(m.addedNodes[j]); }
        } else {
          scan(m.target);
        }
      }
    }).observe(d.body, { childList: true, subtree: true, characterData: true });
  }

  if (d.body) { start(); } else { d.addEventListener('DOMContentLoaded', start); }
})();
